/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import idx from 'idx';
import invariant from 'invariant';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import PendingRolesButtonContainer from 'roleRequests/containers/PendingRolesButtonContainer';
import PendingRolesTableContainer from 'roleRequests/containers/PendingRolesTableContainer';
import PendingRolesList from 'roleRequests/components/PendingRolesList';

import ADMIN_ORGANIZATION_QUERY from 'groups/components/queries/AdminOrganizationQuery.gql';

import './PendingRoles.scss';

import type {
  AdminOrganizationQuery,
  AdminOrganizationQuery_organizations,
} from 'groups/components/queries/__generated__/AdminOrganizationQuery';

type Props = {
  orgId: number,
  data: ReactApolloData<AdminOrganizationQuery>,
  organization: ?AdminOrganizationQuery_organizations,
};

class PendingRoles extends React.Component<Props> {
  render() {
    const { data } = this.props;

    if (data && data.loading) {
      return <CenteredLoadingIndicator />;
    }

    const organization = idx(data, _ => _.organizations[0]);
    invariant(organization, 'Tried to render pending roles without an organization!');

    return <PendingRolesList organizationUuid={organization.uuid} userRole="teacher" />;
  }
}

const withOrganizationAndClass = graphql(ADMIN_ORGANIZATION_QUERY, {
  skip: ({ orgId }) => !orgId,
  options: ({ orgId }) => ({
    variables: { organizationId: orgId },
  }),
});

export {
  PendingRolesButtonContainer as PendingRolesButton,
  PendingRolesTableContainer as PendingRolesTable,
  PendingRolesList,
  PendingRoles,
};

export default withOrganizationAndClass(PendingRoles);
